"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupMembershipStatus = exports.MembershipStatus = exports.MembershipStatusFilterEnum = void 0;
var cerealParse_1 = require("../cerealParse");
var MembershipStatusFilterEnum;
(function (MembershipStatusFilterEnum) {
    MembershipStatusFilterEnum[MembershipStatusFilterEnum["all"] = 0] = "all";
    MembershipStatusFilterEnum[MembershipStatusFilterEnum["inGroup"] = 1] = "inGroup";
    MembershipStatusFilterEnum[MembershipStatusFilterEnum["notInGroup"] = 2] = "notInGroup";
})(MembershipStatusFilterEnum || (exports.MembershipStatusFilterEnum = MembershipStatusFilterEnum = {}));
/**
 * Class representing membership status and providing a static parse method.
 */
var MembershipStatus = /** @class */ (function () {
    function MembershipStatus(id, clientName, hasGroup) {
        this.id = id;
        this.clientName = clientName;
        this.hasGroup = hasGroup;
    }
    /**
     * Parse object potentially representing a MembershipStatus.
     * @param o
     * @return Parse result
     */
    MembershipStatus.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new MembershipStatus(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'clientName'), cerealParse_1.ParseUtils.getBoolean(o, 'hasGroup')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid MembershipStatus: ".concat(e.message));
        }
    };
    return MembershipStatus;
}());
exports.MembershipStatus = MembershipStatus;
/**
 * Class representing group membership status and providing a static parse method.
 */
var GroupMembershipStatus = /** @class */ (function () {
    function GroupMembershipStatus(id, groupName, groupColor, hasGroup) {
        this.id = id;
        this.groupName = groupName;
        this.groupColor = groupColor;
        this.hasGroup = hasGroup;
    }
    /**
     * Parse object potentially representing a GroupMembershipStatus.
     * @param o
     * @return Parse result
     */
    GroupMembershipStatus.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new GroupMembershipStatus(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'groupName'), cerealParse_1.ParseUtils.getString(o, 'groupColor'), cerealParse_1.ParseUtils.getBoolean(o, 'hasGroup')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid GroupMembershipStatus: ".concat(e.message));
        }
    };
    return GroupMembershipStatus;
}());
exports.GroupMembershipStatus = GroupMembershipStatus;
//# sourceMappingURL=membershipStatus.js.map